/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for
 * license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */
export var acceptLanguage = {
  parameterPath: "acceptLanguage",
  mapper: {
    serializedName: "accept-language",
    defaultValue: 'en-US',
    type: {
      name: "String"
    }
  }
};
export var apiVersion = {
  parameterPath: "apiVersion",
  mapper: {
    required: true,
    isConstant: true,
    serializedName: "api-version",
    defaultValue: '2023-06-07',
    type: {
      name: "String"
    }
  }
};
export var filter = {
  parameterPath: ["options", "filter"],
  mapper: {
    serializedName: "$filter",
    type: {
      name: "String"
    }
  }
};
export var imageName = {
  parameterPath: "imageName",
  mapper: {
    required: true,
    serializedName: "imageName",
    constraints: {
      MaxLength: 100,
      MinLength: 1,
      Pattern: /^[-\w\\._\\(\\)]+$/
    },
    type: {
      name: "String"
    }
  }
};
export var labName = {
  parameterPath: "labName",
  mapper: {
    required: true,
    serializedName: "labName",
    constraints: {
      MaxLength: 100,
      MinLength: 1
    },
    type: {
      name: "String"
    }
  }
};
export var labPlanName = {
  parameterPath: "labPlanName",
  mapper: {
    required: true,
    serializedName: "labPlanName",
    constraints: {
      MaxLength: 100,
      MinLength: 1
    },
    type: {
      name: "String"
    }
  }
};
export var location = {
  parameterPath: "location",
  mapper: {
    required: true,
    serializedName: "location",
    constraints: {
      MaxLength: 100,
      MinLength: 1,
      Pattern: /^[-\w\._]+$/
    },
    type: {
      name: "String"
    }
  }
};
export var nextPageLink = {
  parameterPath: "nextPageLink",
  mapper: {
    required: true,
    serializedName: "nextLink",
    type: {
      name: "String"
    }
  },
  skipEncoding: true
};
export var operationResultId = {
  parameterPath: "operationResultId",
  mapper: {
    required: true,
    serializedName: "operationResultId",
    constraints: {
      MaxLength: 100,
      MinLength: 1,
      Pattern: /^[-\w\\._\\(\\)]+$/
    },
    type: {
      name: "String"
    }
  }
};
export var resourceGroupName = {
  parameterPath: "resourceGroupName",
  mapper: {
    required: true,
    serializedName: "resourceGroupName",
    constraints: {
      MaxLength: 90,
      MinLength: 1
    },
    type: {
      name: "String"
    }
  }
};
export var scheduleName = {
  parameterPath: "scheduleName",
  mapper: {
    required: true,
    serializedName: "scheduleName",
    constraints: {
      MaxLength: 100,
      MinLength: 1,
      Pattern: /^[-\w\\._\\(\\)]+$/
    },
    type: {
      name: "String"
    }
  }
};
export var subscriptionId = {
  parameterPath: "subscriptionId",
  mapper: {
    required: true,
    serializedName: "subscriptionId",
    constraints: {
      MinLength: 1
    },
    type: {
      name: "String"
    }
  }
};
export var userName = {
  parameterPath: "userName",
  mapper: {
    required: true,
    serializedName: "userName",
    constraints: {
      MaxLength: 100,
      MinLength: 1,
      Pattern: /^[-\w\\._\\(\\)]+$/
    },
    type: {
      name: "String"
    }
  }
};
export var virtualMachineName = {
  parameterPath: "virtualMachineName",
  mapper: {
    required: true,
    serializedName: "virtualMachineName",
    constraints: {
      MaxLength: 100,
      MinLength: 1,
      Pattern: /^[-\w\\._\\(\\)]+$/
    },
    type: {
      name: "String"
    }
  }
};